import '../config';
import $, { event } from "jquery";

let lastRequest = null;

async function Api(TypeRequest, params, type_api = 'GET',cancelPrevious = false) {
    try {
        if (cancelPrevious && lastRequest && typeof lastRequest.abort === 'function') {
            lastRequest.abort();
        }

        const result = await new Promise((resolve, reject) => {
             const xhr = $.ajax({
                type: type_api,
                cache: true,
                url: `${global.config.domain_url}/rest/${TypeRequest}`,
                data: params,
                headers: {
                    "Accept": "application/json",
                },
                xhrFields: {
                    withCredentials: true // برای ارسال کوکی‌ها
                },
                success(result) {
                    resolve(result); // بازگشت مقدار در صورت موفقیت
                },
                error(err) {
                    if (err.statusText !== 'abort') {
                        reject(err); // مدیریت خطا
                    }
                }
            });
            if (cancelPrevious) {
                lastRequest = xhr;
            }
        });
        return result; // مقدار نهایی بازگردانده می‌شود
    } catch (error) {
        throw error; // مدیریت خطا در جایی که این تابع استفاده می‌شود
    }
}
async function ApiWebhesab(Function, params) {
   
}
export { Api, ApiWebhesab };
